import React, { FC } from 'react';
import { Box, FormControl } from '@mui/material';
import {
  AdditionalFieldKey,
  AdditionalFieldsModel,
  ADDITIONAL_FIELDS_META,
} from '../../model';
import { AdditionalFieldsSectionProps } from '../../types/additionalFieldsForm';
import { NumberMaskField } from '../NumberMaskField';
import { ReadOnlyNumberField } from '../ReadOnlyNumberField';

type FinancialFieldsSectionProps = AdditionalFieldsSectionProps & {
  setValues: React.Dispatch<React.SetStateAction<AdditionalFieldsModel>>;
  debouncedSaveField: (
    key: AdditionalFieldKey,
    value: AdditionalFieldsModel[AdditionalFieldKey],
  ) => void;
};

export const FinancialFieldsSection: FC<FinancialFieldsSectionProps> = ({
  values,
  isFieldsDisabled,
  setValues,
  debouncedSaveField,
}) => (
  <>
    <Box display="flex" gap={2} flexWrap="wrap">
      <NumberMaskField
        label={ADDITIONAL_FIELDS_META.volume.label}
        value={values.volume}
        disabled={isFieldsDisabled}
        onChange={(num) => {
          setValues((prev) => ({ ...prev, volume: num }));
          debouncedSaveField('volume', num);
        }}
      />
      <NumberMaskField
        label={ADDITIONAL_FIELDS_META.clientCpm.label}
        value={values.clientCpm}
        disabled={isFieldsDisabled}
        onChange={(num) => {
          setValues((prev) => ({ ...prev, clientCpm: num }));
          debouncedSaveField('clientCpm', num);
        }}
      />
      <ReadOnlyNumberField
        label={ADDITIONAL_FIELDS_META.clientBudget.label}
        value={values.clientBudget}
      />
    </Box>

    <Box display="flex" gap={2} flexWrap="wrap">
      <FormControl variant="standard" sx={{ minWidth: 200 }}>
        <NumberMaskField
          label={ADDITIONAL_FIELDS_META.returnDiscountPercent.label}
          value={values.returnDiscountPercent}
          disabled={isFieldsDisabled}
          onChange={(num) => {
            setValues((prev) => ({
              ...prev,
              returnDiscountPercent: num,
            }));
            debouncedSaveField('returnDiscountPercent', num);
          }}
        />
      </FormControl>
    </Box>

    <Box display="flex" gap={2} flexWrap="wrap">
      <FormControl variant="standard" sx={{ minWidth: 200 }}>
        <ReadOnlyNumberField
          label={ADDITIONAL_FIELDS_META.returnDiscountSum.label}
          value={values.returnDiscountSum}
        />
      </FormControl>
    </Box>

    <Box display="flex" gap={2} flexWrap="wrap">
      <FormControl variant="standard" sx={{ minWidth: 200 }}>
        <NumberMaskField
          label={ADDITIONAL_FIELDS_META.payCpm.label}
          value={values.payCpm}
          disabled={isFieldsDisabled}
          onChange={(num) => {
            setValues((prev) => ({ ...prev, payCpm: num }));
            debouncedSaveField('payCpm', num);
          }}
        />
      </FormControl>
      <FormControl variant="standard" sx={{ minWidth: 200 }}>
        <ReadOnlyNumberField
          label={ADDITIONAL_FIELDS_META.payBudget.label}
          value={values.payBudget}
        />
      </FormControl>
    </Box>

    <Box display="flex" gap={2} flexWrap="wrap">
      <FormControl variant="standard" sx={{ minWidth: 200 }}>
        <NumberMaskField
          label={ADDITIONAL_FIELDS_META.adFeePercent.label}
          value={values.adFeePercent}
          disabled={isFieldsDisabled}
          onChange={(num) => {
            setValues((prev) => ({ ...prev, adFeePercent: num }));
            debouncedSaveField('adFeePercent', num);
          }}
        />
      </FormControl>
      <FormControl variant="standard" sx={{ minWidth: 200 }}>
        <ReadOnlyNumberField
          label={ADDITIONAL_FIELDS_META.adFeeSum.label}
          value={values.adFeeSum}
        />
      </FormControl>
    </Box>

    <Box display="flex" gap={2} flexWrap="wrap">
      <FormControl variant="standard" sx={{ minWidth: 200 }}>
        <ReadOnlyNumberField
          label={ADDITIONAL_FIELDS_META.budgetToPay.label}
          value={values.budgetToPay}
        />
      </FormControl>
    </Box>
  </>
);
